import { map as _map } from 'lodash'
import moment from 'moment'

import Entity from '_entities/base/EntityNew'

import CompanyLink from '_entities/company/CompanyLink'
import BuildingLink from '_entities/building/BuildingLink'
import PushMessageResidentCategory from '_entities/pushMessage/PushMessageResidentCategory'
import App from '_entities/app/App'
import User from '_entities/user/User'

export const PushMessageMarketingSchema = {
    name: 'PushMessageMarketing',
    primaryKey: 'id',
    properties: {
        apps: { type: 'App[]', entity: App, default: () => [] },
        buildings: { type: 'BuildingLink[]', entity: BuildingLink, default: () => [] },
        companies: { type: 'CompanyLink[]', entity: CompanyLink, default: () => [] },
        createdAt: { type: 'string' },
        createdBy: { type: 'User', entity: User },
        deletedAt: { type: 'string' },
        deletedBy: { type: 'string' },
        id: { type: 'string' },
        pushDate: { type: 'string' },
        residentCategories: { type: 'PushMessageResidentCategory[]', entity: PushMessageResidentCategory, default: () => [] },
        text: { type: 'string' },
        title: { type: 'string' },
        updatedAt: { type: 'string' },
        updatedBy: { type: 'string' },
    },
}

class PushMessageMarketing extends Entity {
    get schema() {
        return PushMessageMarketingSchema
    }

    get dataMap() {
        return {
            created_at: 'createdAt',
            created_by: 'createdBy',
            deleted_at: 'deletedAt',
            deleted_by: 'deletedBy',
            push_date: 'pushDate',
            resident_categories: 'residentCategories',
            updated_at: 'updatedAt',
            updated_by: 'updatedBy',
        }
    }

    static fieldLabels = {
        apps: 'Приложения',
        buildings: 'Дома',
        companies: 'Компании',
        createdAt: 'Дата создания',
        createdBy: 'Кем создано',
        deletedAt: 'Дата удаления',
        deletedBy: 'Кем удалено',
        pushDate: 'Дата отправки',
        residentCategories: 'Типы клиентов',
        text: 'Текст',
        title: 'Заголовок',
        updatedAt: 'Дата изменения',
        updatedBy: 'Кем измененено',
    }

    toArray() {
        return {
            apps: _map(this.apps, (app) => app.value),
            buildings: _map(this.buildings, (building) => building.id),
            companies: _map(this.companies, (company) => company.id),
            push_date: moment.unix(this.pushDate).format('YYYY-MM-DD HH:mm'),
            resident_categories: _map(this.residentCategories, (residentCategory) => residentCategory.id),
            text: this.text,
            title: this.title,
        }
    }
}

export default PushMessageMarketing
